import React, { useEffect, useState } from 'react';
import { Prompt, useHistory } from 'react-router';

import ConfirmModal from 'Shared/components/ConfirmModal/ConfirmModal';

const DEFAULT_TITLE = 'Are you sure?';
const DEAFULT_MESSAGE = 'Your changes will be lost.';
const DEFAULT_SUBMIT_BUTTON_LABEL = "Yes, I'm sure";
const DEFAULT_CANCEL_BUTTON_LABEL = 'Cancel';

type Props = {
  when: boolean;
  children?: React.ReactNode;
  title?: string;
  message?: string;
  submitButtonLabel?: string;
  cancelButtonLabel?: string;
  onSubmitClick?: Function;
};

function RouteChangeWarningModal({
  when,
  children,
  title = DEFAULT_TITLE,
  message = DEAFULT_MESSAGE,
  submitButtonLabel = DEFAULT_SUBMIT_BUTTON_LABEL,
  cancelButtonLabel = DEFAULT_CANCEL_BUTTON_LABEL,
  onSubmitClick,
}: Props) {
  const history = useHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleModalToggle = () => setIsModalOpen(prev => !prev);

  const handleMessageTrigger = nextLocation => {
    if (!confirmedNavigation) {
      setIsModalOpen(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmClick = () => {
    setIsModalOpen(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation) {
      setConfirmedNavigation(false);

      if (onSubmitClick) {
        onSubmitClick();
      } else if (lastLocation) {
        history.push(lastLocation.pathname);
      }
    }
  }, [confirmedNavigation, lastLocation, history, onSubmitClick]);

  const body = children || <div className="px-3 py-4">{message}</div>;

  return (
    <>
      <Prompt when={when} message={handleMessageTrigger} />

      <ConfirmModal
        isOpen={isModalOpen}
        title={title}
        message={message}
        cancelButtonLabel={cancelButtonLabel}
        confirmButtonLabel={submitButtonLabel}
        onToggle={handleModalToggle}
        onConfirmClick={handleConfirmClick}
      >
        {body}
      </ConfirmModal>
    </>
  );
}

export default RouteChangeWarningModal;
